<script setup>
	/* eslint-disable */
	import axios from 'axios';
	import {onMounted, onUnmounted, reactive, watch, shallowRef, toRaw} from 'vue';
	import {Loader} from '@googlemaps/js-api-loader';
	import _ from 'lodash';

	const GOOGLE_MAPS_API_KEY = 'AIzaSyD5E6OUmpZyMjej99I2wzy4xx8qvmQB8As';

	const loader = new Loader(
		{
			apiKey: GOOGLE_MAPS_API_KEY,
			version: "weekly",
			libraries: ['drawing', 'geometry', 'places', 'visualization', 'marker'],
		}
	);

	let resultsMap 	= shallowRef(null);
	let state 		= reactive(
		[	
			'id',
			'markers',
			'isSupported',
			'isGranted',
			'results',
			'userPos',
			'form',
			'formLoading',
			'services',
			'message'
		]
	);

	state.id 				= false;
	state.form 				= {};
	state.form.status 		= {};
	state.form.service 		= {};
	state.services 			= {};
	state.formLoading 		= null;
	state.isSupported 		= false;
	state.isGranted 		= false;
	state.userPos 			= false;
	state.message 			= new Array();

	// check for isGranted
	onMounted(async () => {
		// setup axios.
		axios.defaults.baseURL = process.env.VUE_APP_WP_REST;

		if (typeof window.kaluna_search_params === 'undefined') {
			window.kaluna_search_params = {};

			window.kaluna_search_params.get_professionals = 'https://approved.takingthegrrr.local/wp-json/kaluna/v1/professional/get';
			window.kaluna_search_params.rest_url = 'https://approved.takingthegrrr.local/wp-json/';
		} else {
			if (typeof window.kaluna_search_params.rest_url !== 'undefined') {
				axios.defaults.baseURL = window.kaluna_search_params.rest_url;
			}
		}

		// collect any params passed via the url.
		collectUrlParams();

		// collect services.
		fetchAllServices();

		// load google maps stuff.
		await loader.load();

		// check whether geolocation is supported.
		state.isSupported = 'navigator' in window && 'geolocation' in navigator;

		// check whether the user has granted permission to geolocate.
		navigator.permissions
			.query({ name: "geolocation" })
			.then((permissionStatus) => {
				state.isGranted = permissionStatus.state;

				permissionStatus.onchange = () => {
					state.isGranted = permissionStatus.state;
				};
			}).then(() => {
				if ('granted' === state.isGranted) {
					navigator.geolocation.watchPosition(
						handleWatchPosition, 
						handleWatchPositionError,
						{
							maximumAge: 60000,
							timeout: 5000,
							enableHighAccuracy: true
						}
					);
				} else {
					if (typeof state.form.postal_code !== 'undefined' && state.form.postal_code !== '') {
						axios.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + state.form.postal_code + '&key=' + GOOGLE_MAPS_API_KEY).then(response => {
							if (200 === response.status && Object.values(response.data).length > 0) {
								if (false === state.userPos) {
									state.userPos = {};
									state.userPos.coords = {};
								}

								state.userPos.coords.latitude = response.data.results[0].geometry.location.lat;
								state.userPos.coords.longitude = response.data.results[0].geometry.location.lng;
							}
						});
					}
				}
			});
	});

	/**
	 * watch function which will trigger renderMap()
	 */
	watch(
		() => state.userPos,
		(userPos) => {
			if (false !== userPos && typeof userPos.coords !== 'undefined') {
				renderMap();
			}
		}
	);

	/**
	 * functions
	 */
	
	const onSubmit = () => {
		state.form_loading 	= true;
		state.results 		= {};
		state.message		= {};

		if (typeof state.form.postal_code !== 'undefined' && state.form.postal_code !== '') {
			axios.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + state.form.postal_code + '&key=' + GOOGLE_MAPS_API_KEY).then(response => {

				if (200 === response.status && Object.values(response.data).length > 0) {
					state.userPos = new Array();
					state.userPos.coords = new Array();

					state.userPos.coords.latitude = response.data.results[0].geometry.location.lat;
					state.userPos.coords.longitude = response.data.results[0].geometry.location.lng;
				}
			}).then(() => {
				actionFilterProfessionals();
			});
		} else {
			actionFilterProfessionals();
		}
	};
	
	const handleWatchPosition = (location) => {
		if (false === state.userPos) {
			state.userPos = {};
			state.userPos.coords = {};
		}

		state.userPos.coords.latitude = location.coords.latitude;
		state.userPos.coords.longitude = location.coords.longitude;
	};
	
	const handleWatchPositionError = (error) => {
		console.log(error);
	};

	const renderMap = () => {
		state.markers = new Array();

		let position = { lat: state.userPos.coords.latitude, lng: state.userPos.coords.longitude };

		resultsMap = new google.maps.Map(document.getElementById('resultsMap'), {
			mapId: 		'76ed9f244aaf7a5',
			center: 	new google.maps.LatLng(position),
			zoom: 		12,
			maxZoom: 	16,
			disableDefaultUI: true,
			zoomControl: true,
		    scaleControl: true
		});

		if (typeof window.found_professionals !== 'undefined') {
			if ('string' === typeof window.found_professionals) {
				window.found_professionals = JSON.parse(window.found_professionals);
			}

			if (Object.values(window.found_professionals).length <= 0) {
				return;
			}

			state.results = window.found_professionals;

			let urlParams	= new URLSearchParams(window.location.search);
			let radius		= false;

			if (urlParams.has('radius')) {
				radius = parseInt(urlParams.get('radius'));
			}

			getAndFilterProfessionals(radius);
		}
	};

	const actionFilterProfessionals = () => {
		axios.post(
			window.kaluna_search_params.get_professionals,
			{
				data: state.form
			}
		)
		.then(response => {
			if (typeof state.results === 'undefined') {
				state.results = new Array();
			};

			state.results = response.data.posts.filter(prof => prof.acf.post_code !== '');

			getAndFilterProfessionals(response.data.radius);

			state.form_loading = false;
		})
		.catch( error => {
			state.message = {
				text: 'Sorry, there was an error, please try again',
				status: 'danger'
			};
		})
	};

	const getAndFilterProfessionals = (radius = false) => {
		state.markers = Object.values(state.markers).forEach(marker => marker.map = null);
		state.markers = new Array();

		if (typeof state.results === 'undefined') {
			return;
		}

		let position = { lat: state.userPos.coords.latitude, lng: state.userPos.coords.longitude };
		state.results = state.results.filter(prof => prof.acf.post_code !== '');

		Promise.all(
			state.results.map(prof => {
				return axios.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + prof.acf.post_code + '&key=' + GOOGLE_MAPS_API_KEY)
					.then(prof_resp => {
						if (typeof prof_resp.data.results !== 'undefined' && (typeof prof_resp.data.results[0] !== 'undefined' && Object.keys(prof_resp.data.results[0]).length > 0)) {

							let radius		= false;
							let location 	= prof_resp.data.results[0].geometry.location;
							let distance 	= google.maps.geometry.spherical.computeDistanceBetween(new google.maps.LatLng(position), new google.maps.LatLng(location));

							prof.distanceToUser = parseInt((distance * 0.000621371192).toFixed(2));
						}

						prof.location = prof_resp.data.results[0].geometry.location;

						return prof;
					})
					.catch(error => {
						return prof; // Return prof even if there was an error, to avoid issues in Promise.all
					});
			})
		).then(updatedResults => {
			// if we're search without radius.
			if (false !== radius) {
				updatedResults = Object.values(updatedResults).filter(prof => radius >= prof.distanceToUser);
			}

			state.results = updatedResults.sort((a, b) => a.distanceToUser - b.distanceToUser);

			if (Object.values(state.results).length <= 0) {
				state.message = {
					text: 'We failed to find any professionals in your area',
					status: 'danger'
				}

				return;
			} else {
				if (1 === Object.values(state.results).length) {
					state.message = {
						text: 'We found one professional in your area!',
						status: 'success'
					}
				} else {
					state.message = {
						text: 'We found ' + Object.values(state.results).length + ' professionals in your area!',
						status: 'success'
					}
				}
			}

			let bounds = new google.maps.LatLngBounds();

			state.results.forEach(prof => {
				const parser = new DOMParser();

				let status_class = 'is_' + prof.primary_status.name;

				const pinSvgString = '<svg class="' + status_class.replaceAll(' ', '-', status_class).toLowerCase() + '" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"/></svg>';

				const pinSvg = parser.parseFromString(
				  pinSvgString,
				  "image/svg+xml",
				).documentElement;

				const infoWindow = new google.maps.InfoWindow();

				let marker = new google.maps.marker.AdvancedMarkerElement({
					map: resultsMap,
					position: prof.location,
					title: prof.title.rendered,
					content: pinSvg,
					gmpClickable: true,
				});

				// Add a click listener for each marker, and set up the info window.
				marker.addListener("click", ({ domEvent, latLng }) => {
					const { target } = domEvent;

					state.markers.forEach(m => infoWindow.close());

					infoWindow.setContent(

						'<div class="flow-2xs">' +

						'<h2 class="font-mid family-heading"><a href="' + prof.link + '">' + prof.title.rendered + '</a></h2>' +

						'<div><a href="' + prof.link + '">View profile</a></div>'

						);
					infoWindow.open(marker.map, marker);
				});

				state.markers.push(marker);
				bounds.extend(prof.location);
			});

			resultsMap.fitBounds(bounds);
		});
	};
	
	const collectUrlParams = () => {
		let urlParams	= new URLSearchParams(window.location.search);

		urlParams.forEach((value, key) => {
			let sub_key = key.match(/\[(.*?)\]/);

			if (null === sub_key) {
				state.form[ key ] = value;

				return;
			}

			let san_key = key.replaceAll(sub_key[0], '');

			if (typeof state.form[ san_key ] === 'undefined') {
				state.form[ san_key ] = new Array;
			}

			if (typeof state.form[ san_key ][ sub_key[1] ] === 'undefined') {
				state.form[ san_key ][ sub_key[1] ] = Boolean(true);
			}
		});
	};

	const fetchAllServices = () => {
		axios.get(
			window.kaluna_search_params.rest_url + 'wp/v2/services'
		)
		.then(response => {
			if (200 === response.status) {
				state.services = response.data;
			}
		})
		.catch( error => {
			console.log(error);
		})
	};

</script>

<template>
	<form @submit.prevent="onSubmit" class="flow-l" :class="true === state.formLoading ? 'is_loading' : false">
		<div class="row">
			<div class="col-12 col-md-auto flow-s">
				<legend class="weight-bold font-small">Tell us what you're looking for:</legend>

				<fieldset class="row checkbox-row">
					<div class="col-auto">
						<input type="checkbox" v-model="state.form.status.groomer" value="1" id="status_groomer">
						<label class="is_approved-groomer" for="status_groomer">Groomer</label>
					</div>

					<div class="col-auto">
						<input type="checkbox" v-model="state.form.status.behaviourist" value="1" id="status_behaviourist">
						<label class="is_approved-behaviourist" for="status_behaviourist">Behaviourist</label>
					</div>

					<div class="col-auto">
						<input type="checkbox" v-model="state.form.status.trainer" value="1" id="status_trainer">
						<label class="is_approved-trainer" for="status_trainer">Trainer</label>
					</div>
				</fieldset>
			</div>

			<div class="col-12 col-md-auto flow-s" v-show="'granted' !== state.isGranted" id="requires_postal_code">
				<label for="postal_code" class="weight-bold font-small">What is your post code?</label>

				<fieldset class="row checkbox-row">
					<div class="col-auto">
						<input type="text" v-model="state.form.postal_code" id="postal_code">
					</div>
				</fieldset>
			</div>

			<div class="col-12 col-md-auto">
				<fieldset class="flow-s">
					<div>
						<label class="weight-bold font-small" for="radius">How far can you travel?</label>
					</div>

					<select v-model="state.form.radius" id="radius">
						<option value="">-- Make a selection --</option>
						<option value="10">10 miles</option>
						<option value="20">20 miles</option>
						<option value="30">30 miles</option>
						<option value="40">40 miles</option>
						<option value="50">50 miles</option>
						<option value="60">60 miles</option>
						<option value="70">70 miles</option>
						<option value="80">80 miles</option>
						<option value="90">90 miles</option>
						<option value="100">100 miles</option>
					</select>
				</fieldset>
			</div>

			<div v-if="Object.values(state.services).length > 0" class="col-12 flow-s">
				<legend class="weight-bold font-small">Tell us what services you're looking for:</legend>

				<fieldset class="row checkbox-row">
					<div v-for="service in state.services" class="col-auto">
						<input type="checkbox" v-model="state.form.service[ service.slug ]" value="1" :id="'service_' + service.slug">
						<label class="is_service bg-mono-darkest color-mono-lightest" :for="'service_' + service.slug">{{service.name}}</label>
					</div>
				</fieldset>
			</div>

			<div class="col-12">
				<button type="submit" class="button bg-brand-accent color-mono-lightest">
					Search our professionals
				</button>
			</div>
		</div>

		<div v-if="false !== state.message" class="message align-items-center" :class="state.message.status">
			<svg v-if="state.message.status === 'success'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>

			<svg v-if="state.message.status === 'danger'"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>

			<p>{{state.message.text}}</p>
		</div>
	</form>

	<div style="min-height:50vh;" v-if="false !== state.results || Object.values(state.results).length > 0" id="resultsMap"></div>
</template>